class ProductCategoryController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'treeItems'
		'category'
		'productsList'
		'ProductCategoryRepository'
		'ProductRepository'
		'CopyService'
		'EntityAttributeService'
		'ConfigurationService'

	initialize: ->
		@mainCrud.entityType = 'general.category'
		@mainCrud.entityTitle = 'general.category'

		@allowImageEdit = @ConfigurationService.getValue('Backoffice.Setting.Cdn.Url') == null
		@isOrdinEnabled = @ConfigurationService.isEnabled('Backoffice.Setting.Integrations.EnableOrdin')

		{count: @productsCount, data: @products} = @productsList
		@pager = new TableService(@productsCount, => @search())

		if @category.id?
			@mainCrud.entityTitle = @category.name
			@mainCrud.isNewEntity = false

			@invalidParents = @getInvalidParents(@category.id)
		else
			@mainCrud.isNewEntity = true

		# Populate parent input select with existing categories
		@categories = @treeItems

		@tabs = [
			{
				title: 'wbo.category.tabs.category.details'
				selector: '#tab-category-details'
			}
			{
				title: 'wbo.category.tabs.products.in.category'
				subtitle: "(#{@productsCount})"
				disabled: @mainCrud.isNewEntity
				inactive: @productsCount == 0
				selector: '#tab-category-products'
			}
		]

		@attributesService = @EntityAttributeService.getNewInstance()
		@attributesService.setEntity(
			@category,
			'BACKEND_PRODUCT_CATEGORY_ATTRIBUTE_TYPE',
			{
				exclude_from_discounts: '0'
			}
		)

	save: ->
		# Do not show error if previous set
		@childCategoryExist = false

		@attributesService.persistAttributes()

		category = @CopyService.copy @category, 'image'

		delete category.path

		@ProductCategoryRepository
			.saveWithAttachment category, @mainCrud.isNewEntity
			.then (response) =>
				@afterSave response

				@category.image = response.data.image
			.catch (response) =>
				@handleErrors response

	delete: ->
		@childCategoryExist = false

		if @getInvalidParents(@category.id).length > 1
			@childCategoryExist = true

		if !@childCategoryExist
			@deleteEntity @ProductCategoryRepository, @category

	getInvalidParents: (categoryIds) ->
		categoryIds = [categoryIds] if typeof categoryIds is 'string'
		invalid = categoryIds

		## Add children
		for categoryId in categoryIds
			children = _.where(@categories, {parent_id: categoryId})

			if children
				childIds = @getInvalidParents(_.pluck(children, "id"))
				invalid = invalid.concat(childIds)

		return invalid

	isValidParentId: (parentId) ->
		if !parentId
			return true

		return !_.contains(@invalidParents, parentId)

	search: ->
		query = @ProductRepository.getQuery()
		query.with 'product_categories'
		query.criteria 'product_categories.id', '=', @category.id
		query.setPagination @pager.page * @pager.pageSize - @pager.pageSize, @pager.pageSize

		@ProductRepository
			.findByQuery query
			.then (response) =>
				@products = response.data

	fillFieldsWithParentData: (parentId, overwrite = false) ->
		parentCategory = _.find(@categories, {id: parentId})

		if overwrite && !parentCategory
			@category.age_restriction = null
			@category.counting_interval = null

		if !parentCategory
			return

		if overwrite
			@category.age_restriction = parentCategory.age_restriction
			@category.counting_interval = parentCategory.counting_interval
		else
			@category.age_restriction = @category.age_restriction || parentCategory.age_restriction
			@category.counting_interval = @category.counting_interval || parentCategory.counting_interval
